// Presentation constants for the variable-scope UI (picker + badge).

// vs-icon (material) names used to represent a scope level.
export const SCOPE_ICON = {
  GLOBAL: 'language', // globe
  MARKET: 'storefront' // shop
}

// Render sentinels for the scope picker's icon slot: the bot levels are drawn with the
// custom BotIcon component (and, for bot+market, BotIcon + the market icon), so they can't
// be expressed as a plain vs-icon name.
export const SCOPE_ICON_TYPE = {
  BOT: 'bot',
  BOT_MARKET: 'bot_market'
}
